var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E99233;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,300C67.1,300,0,232.9,0,150C0,67.1,67.4-0.2,150.2,0C233.1,0.2,300.1,67.4,300,150.1 C299.9,233,232.8,300,150,300z M276.6,149.9C276.4,80,219.7,23.4,149.9,23.4C80.1,23.5,23.5,80.2,23.4,150 c0,69.9,56.9,126.7,126.7,126.6C220.1,276.4,276.7,219.6,276.6,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.7,167.7c0,6.3,0.1,12.5,0,18.8c-0.1,7.5-6,12.6-13.4,11.7c-5.6-0.7-9.9-5.3-10-11.2 c-0.1-10-0.2-19.9,0-29.9c0.1-6.1,4.3-10.7,10.6-11.3c6.2-0.6,11.8-2,16.7-6.2c7.2-6.4,9.8-17.4,6-26.5 c-3.7-8.9-13.1-14.8-22.6-14.2c-12.7,0.8-21.4,9.7-22.4,23c-0.5,6.3-4.1,10.8-9.5,11.7c-7.7,1.3-14-4.2-14-12.2 c0.2-20.5,14.6-39.1,34.5-44.4c31.2-8.4,61.4,16.4,59.2,48.6c-1.3,18.6-14.1,35-31.9,41C163.9,166.9,162.9,167.3,161.7,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.9,207.2c8-0.1,14.6,6.3,14.8,14.3c0.2,8.1-6.4,14.8-14.5,14.9c-8,0.1-14.6-6.3-14.8-14.3 C135.2,214,141.7,207.3,149.9,207.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuFaq);
export default __webpack_public_path__ + "static/media/icon-menu-faq.7ea4ad31848b8b91e533a25f4cf3f803.svg";
export { ForwardRef as ReactComponent };